import { jsx as _jsx } from "react/jsx-runtime";
import BryxTypography from "./BryxTypography";
import BryxColors from "../types/theme";
import { orFragment } from "../utility/tsx";
const BryxErrorText = (props) => {
    return orFragment(_jsx(BryxTypography, { color: BryxColors.lightNotify("error"), variant: "body1", children: props.error ?? "" }), !!props.error);
};
export default BryxErrorText;
